import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  loading: false,
  appSettingData: {
    error: {
      isError: false,
      message: '',
    },
    items: {},
    loading: false,
  },
};

export const appSettingSlice = createSlice({
  name: 'appSetting',
  initialState,
  reducers: {
    setAppSettingData: (state, action) => {
      state.appSettingData.items = action.payload;
      state.appSettingData.error = {
        isError: false,
        message: '',
      };
    },
    setAppSettingLoading: (state, action) => {
      state.appSettingData.loading = action.payload;
    },
    setAppSettingError: (state, action) => {
      state.appSettingData.items = {};
      state.appSettingData.error = action.payload;
    },
  },
});

export default appSettingSlice.reducer;

// Action creators are generated for each case reducer function
export const { setAppSettingData, setAppSettingLoading, setAppSettingError } =
  appSettingSlice.actions;

export const appSettingItemsSelector = (state) => state.appSetting;
